module.exports = __webpack_public_path__ + "static/img/banner_01.86383de.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productAndService/banner_01.png
// module id = Wghi
// module chunks = 1